import React from "react";
import Layout from "../HorizontalMenu/Menu";
import Navbar from "../HorizontalMenu/Navbar";
import '../global/GlobalCSS.css'
import GenericDynamic from "./GenericDynamic";

const GenericIndex = () => {
    return (
        <>
            <Layout children={Navbar} />
            <div className="page-content">
                <div className="mr-25"></div>
                <div className="form-div-temp">
                    <GenericDynamic />
                </div>
            </div>
        </>
    )
}

export default GenericIndex;